import { PropsWithChildren } from 'react';

import { Box, BoxProps, useTheme } from '@material-ui/core';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore FormFieldsBox and delete. */
export const FormFieldsBoxMui = ({
  spacing = 3,
  children,
  ...boxProps
}: PropsWithChildren<{ spacing?: number } & BoxProps>) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gridGap={theme.spacing(spacing)}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
